import { Routes, Route, Navigate } from 'react-router-dom';
import OptionsSectionSidebar from '../../components/sidebar/OptionsSectionSidebar';
import CategoriesSectionSidebar from '../../components/sidebar/CategoriesSectionSidebar';
import UserSectionSidebar from '../../components/sidebar/UserSectionSidebar';

import { Toaster } from 'react-hot-toast'
import { useEffect, useState, createContext, useContext } from 'react'
import {getLocalToken} from '../../services/authorizationService' ;

import CategoryFormPage from '../Category/CategoryFormPage';
import CategoryProjectsPage from '../Category/CategoryProjectsPage'
import HomePage from '../Home/HomePage';
import LoginPage from './LoginPage';
import SigninPage from './SigninPage';
import ResetPasswordPage from './ResetPasswordPage';
import ResetPasswordRequestPage from './ResetPasswordRequestPage';

import { jwtDecode } from 'jwt-decode'


const AuthContext = createContext();
export const AuthData = () => useContext(AuthContext);

const AuthWrapper = () => {
    const [ user, setUser ] = useState({token: "", isAuthenticated: false, fullName: '', email:''})
    
    useEffect(()=>{
        async function getCookie() {
            var token = getLocalToken()
            if(token === ''){ 
                setUser({token: "", isAuthenticated: false, fullName: '', email:''});
            }else{
                const userData = jwtDecode(token)
                setUser({token: token, isAuthenticated: token!=="", fullName: userData.unique_name, email:userData.email})
            }
            return
        }
        getCookie()
    },[])

    const renderUserSectionSidebar = () => {
        return(
            <div className='h-[98px] bg-gray-100 flex-none rounded-lg mb-2 ml-2 px-2'>
                <UserSectionSidebar />
            </div>
        )
    }

    const renderOptionsSectionSidebar = () => {
        return(
            <div className='h-[296px] bg-gray-100 flex-none rounded-lg mb-2 ml-2 px-2'>
                <OptionsSectionSidebar />
            </div>
        )
        return
    }
    const renderCategoriesSectionSidebar = () => {
        return(
            <div className='h-[590px] bg-gray-100 flex-none rounded-lg mb-2 ml-2 px-2'>
                <CategoriesSectionSidebar />
            </div>
        )
    }

    const logoutRefresh = () => {
        setUser({token:'', isAuthenticated: false, fullName: '', email:''})
        return
    }

    const loginRefresh = (user) => {
        const userData = jwtDecode(user.token)
        setUser({token: user.token, isAuthenticated: user.token !== "", fullName: userData.unique_name, email:userData.email})
    }

    const forceRefresh = (user) => {
        const userData = jwtDecode(user.token)
        setUser({token: user.token, isAuthenticated: user.token !== "", fullName: userData.unique_name, email:userData.email})
    }

return (
    <AuthContext.Provider value={{user, logoutRefresh, loginRefresh, forceRefresh}}>
        <div className="container h-full flex">
            <div className='w-[25%] mt-2'>
                {renderUserSectionSidebar()}
                {renderOptionsSectionSidebar()}
                {renderCategoriesSectionSidebar()}
            </div>
            <div className='h-[1000px] w-full mx-auto ml-2 mt-2 bg-gray-100 rounded-lg overflow-y-scroll'>
                <Routes>
                    <Route path='/login' element={<LoginPage />} />
                    <Route path='/signin' element={<SigninPage />} />
                    <Route path='/reset-password-request' element={<ResetPasswordRequestPage />} />
                    <Route path='/reset-password' element={<ResetPasswordPage />} />

                    <Route path='/' element={<HomePage />} />
                    <Route path='/category-add' element={<CategoryFormPage />} />
                    <Route path='/category/:id' element={<CategoryFormPage />} />
                    <Route path='/category-projects/:id' element={<CategoryProjectsPage />} />

                </Routes>
                <Toaster />
            </div>
        </div>
    </AuthContext.Provider>
    )
}

export default AuthWrapper